import { LuAudioLines } from "react-icons/lu";

import VideoPlayer from "@/components/VideoPlayer";
import ImagePreview from "./ImagePreview";

/**
 * Renders whatever an asset's `mediaType` calls for, and nothing else — no
 * chrome, no actions, no layout assumptions beyond filling its parent. Shared
 * by AssetPreview (the modal) and AssetsListAssetPreview (the overlay), which
 * differ only in the props they hand down.
 *
 * The trim props are forwarded straight to VideoPlayer and only mean anything
 * for a video; an image or audio asset ignores them.
 *
 * @input {asset: {_id: 'a1', mediaType: 'video'}, allowTrim: true, initialTrimInTime: 2}
 */
export default function AssetMedia({
  asset,
  videoPlayerRef,
  autoPlay = true,
  allowTrim = true,
  initialTrimInTime = null,
  initialTrimOutTime = null,
  constrainPlaybackToTrim = false,
  onTrimChange,
  onMediaInfoChange,
}) {
  if (!asset) return null;

  if (asset.mediaType === "video") {
    return (
      <div className="AssetMedia AssetMedia--video w-full h-full flex items-center justify-center bg-black">
        <VideoPlayer
          ref={videoPlayerRef}
          asset={asset}
          autoPlay={autoPlay}
          allowTrim={allowTrim}
          initialTrimInTime={initialTrimInTime}
          initialTrimOutTime={initialTrimOutTime}
          constrainPlaybackToTrim={constrainPlaybackToTrim}
          onTrimChange={onTrimChange}
          onMediaInfoChange={onMediaInfoChange}
          className="w-full h-full"
        />
      </div>
    );
  }

  if (asset.mediaType === "audio") {
    return (
      <div className="AssetMedia AssetMedia--audio w-full h-full flex flex-col items-center justify-center gap-6 bg-black p-6">
        <LuAudioLines className="w-24 h-24 text-secondary-foreground/60" />
        <audio
          src={asset.url}
          autoPlay={autoPlay}
          controls
          className="w-full max-w-[480px]"
        />
      </div>
    );
  }

  if (asset.mediaType === "image") {
    return <ImagePreview asset={asset} />;
  }

  return (
    <div className="AssetMedia AssetMedia--unsupported w-full h-full flex items-center justify-center bg-black text-secondary-foreground/60 text-sm">
      No preview available
    </div>
  );
}
